import i18n from '@/configs/i18n'
import vi from './vi.json'
import en from './en.json'

// Registers this module's `notification` namespace (see configs/i18n).
i18n.addResourceBundle('vi', 'notification', vi)
i18n.addResourceBundle('en', 'notification', en)
